<template>
  <v-expand-transition>
    <div v-show="isVisible" class="alert mb-2 elevation-2 pa-1 text--white">
      <div v-if="sibling && sibling.compare_mode === true" class="start-compare layout align-center">
        <div>New Master Version available</div>
        <v-spacer />
        <v-btn
          small
          depressed
          color="white"
          @click="$store.dispatch('localization/startComparison', slide._id)"
        >
          Update Now
        </v-btn>
      </div>
      <div v-else>
        <div class="top px-3">
          Localization Mode
        </div>
        <v-divider dark />
        <div class="down px-3 layout align-center">
          <div class="layout align-center">
            <v-checkbox
              v-if="sibling"
              v-model="sibling.checked_group"
              dark
              label="Checked Group"
              color="white"
              @change="e => checkCriteria('group', e)"
            />
            <v-spacer />
            <v-checkbox
              v-if="sibling"
              v-model="sibling.checked_references"
              color="white"
              label="Checked References"
              small
              dark
              @change="e => checkCriteria('reference', e)"
            />
            <v-spacer />
            <v-checkbox
              v-if="sibling"
              v-model="sibling.checked_translation"
              color="white"
              label="Checked Translation"
              small
              dark
              @change="e => checkCriteria('translation', e)"
            />
          </div>

          <div v-if="sibling" class="ml-4 layout align-center justify-end">
            <v-btn
              :disabled="
                !sibling.checked_translation || !sibling.checked_references || !sibling.checked_group
              "
              color="white"
              depressed
              @click.stop="endLocalization"
            >
              Done
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
import {
  endLocalization,
  getSiblingByLocale,
  updateAcceptenceCriteria
} from '../../services/graph/localization.graph';
import { EventBus } from '../../event-bus';

export default {
  name: 'SlideGroupAlert',
  props: {
    isVisible: Boolean,
    slide: Object
  },
  data() {
    return {
      sibling: null
    };
  },
  mounted() {
    const self = this;
    EventBus.$on('end-compare-mode', () => {
      self.sibling.compare_mode = false;
    });
    this.getSiblingForCountry();
  },
  methods: {
    async checkCriteria(criteria, value) {
      await updateAcceptenceCriteria({ slide: this.slide._id, criteria, value, country: this.slide.country });
      this.getSiblingForCountry();
    },
    async endLocalization() {
      try {
        await endLocalization({ slide: this.slide._id });
        await this.getSiblingForCountry();
        this.$emit('end-localization');
      } catch (e) {
        this.$store.dispatch('alerts/warning', 'Can not end localization. Please try again.');
      } finally {
        this.$store.dispatch('alerts/success', 'Slide is localized.');
      }
    },
    getSiblingForCountry() {
      return getSiblingByLocale({
        slideId: this.slide._id,
        forWhat: 'slave',
        country: this.slide.country
      }).then(({ data }) => {
        this.sibling = data.getSiblingForSlaveByLocale;
      });
    }
  }
};
</script>

<style scoped>
.alert {
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  background-color: var(--salmon);
  color: white;
}
.top {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #ffffff;
  height: 50%;
}
</style>
